import InvestmentMemo from "./InvestmentMemo";
import { useAtom, useAtomValue } from "jotai";
import { showCompanyListAtom } from "@/features/Navigation/state";
import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { MemoNavigator } from "./components/MemoNavigator";
import { useCompany } from "@/apps/CompanyApp/hooks/useCompany";
import { Spinner } from "@/ui/atoms/Spinner";
import { RightDrawerContent } from "@/features/Navigation/components/RightDrawerContent";
import {
    rightDrawerOpenAtom,
    rightDrawerSizeAtom,
} from "@/features/Navigation/state";
import { AIMPanelContainer } from "./panels/AIMPanelContext/AIMPanelContainer";
import { useMetricHydration } from "@/features/Metrics/useMetricHydration";
import {
    FINANCE_API_METRIC_LIST,
    FINANCE_LAB_METRIC_LIST,
} from "./InvestmentMemo.const";

export default function InvestmentMemoPage() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const drawerIsOpen = useAtomValue(rightDrawerOpenAtom);
    const rightDrawerSize = useAtomValue(rightDrawerSizeAtom);
    const company = useCompany();
    useMetricHydration(FINANCE_API_METRIC_LIST, FINANCE_LAB_METRIC_LIST);

    if (!company.company) {
        return <Spinner fullScreen />;
    }

    return (
        <div className="flex size-full">
            {!showCompanyList && (
                <SidebarPortal>
                    <MemoNavigator />
                </SidebarPortal>
            )}

            {drawerIsOpen && (
                <RightDrawerContent size={rightDrawerSize}>
                    <AIMPanelContainer />
                </RightDrawerContent>
            )}

            <InvestmentMemo />
        </div>
    );
}
